
<section class="card-body">
  <slot></slot>
</section>
